<!-- BANNER -->
<!-- <section class="banner-sec" *ngIf="homeBannerList">
  <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
    fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
    <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100" fxFlexFill>
      <div class="swiper-container" [swiper]="bannerConfig" (indexChange)="onIndexChange($event)">
        <div class="swiper-wrapper">
    
          <div class="swiper-slide" *ngFor="let single of homeBannerList">
            <div class="banner-img">
              <img [src]="single.image.url" alt="banner_img">
            </div>
            <div class="wrapper banner_container">
               <div>
                 <div class="banner-content">
                   <h1>Encompassing the contribution
                     of every villager</h1>
                 </div>
               </div>
             </div>
            <div class="banner_overlay"></div>
          </div>

        </div>
        <div class="swiper-pagination swiper-pagination-banner"></div>
      </div>
    </div>
  </div>
</section> -->
<!-- banner_flower -->
<!-- <div class="banner_flower sec-padding">
  <img src="../../../../../assets/images/banner-elevation.png" alt="img">
</div> -->
<app-home-banner></app-home-banner>
<!-- Latest News -->

<div class="latest_news_sec">
  <div class="wrapper">
    <div class="new_flex">
      <h2 class="title">Latest Updates</h2>
      <div class="marquee_news">
        <marquee>Define activitices thant can Mobilize the complete community<span>Use resources from running goverment
            schemes</span></marquee>
      </div>
    </div>
  </div>
</div>
<!-- Important  Document Pins -->
<section class="document_pins_sec">
  <!-- <div class="elevation_left"></div>
  <div class="elevation_center"></div> -->
  <div class="wrapper">
    <div class="document_pins_row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
      fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
      <div class="document_pins_leftcolumn" fxLayout="column" fxFlex.xl="70" fxFlex.lg="70" fxFlex.md="70"
        fxFlex.sm="100" fxFlex.xs="100" fxFlexFill>

        <div class="model_village_sec" *ngIf="selectedLanguage==='en'">
          <div class="custom_heading">
            <h2 class="title">
              Narmetta as Model Village
            </h2>
          </div>
          <div class="model_village_banner">
            <video mute preload="auto" controls>
              <source src="../../../../../assets/images/Narmetta drone vedio (2019) before adoption.mp4"
                type="video/mp4">
            </video>
          </div>
          <div class="document_box_flex">
            <!-- document_box -->
            <div class="document_box">
              <div class="document_img">
                <img src="../../../../../assets/images/water supp.jpg" alt="important_document_1">
              </div>
              <div class="document_content">
                <h3>Purified drinking water</h3>
                <p>Water deprivation of the poorest is a widely recognised phenomenon all over the world. It is
                  estimated that over one billion people across the world do not have access to safe, clean drinking
                  water. Although, as a basic human need, it is an integral constituent of the right to life.</p>
              </div>
              <div class="button_box" fxLayoutAlign="center center">
                <button class="btn btn-sm read-btn" mat-button
                  [routerLink]="['/government_offices_settings/community_water_supplys']">Read More</button>
              </div>
            </div>
            <!-- document_box -->
            <div class="document_box">
              <div class="document_img">
                <img src="../../../../../assets/images/purified.png" alt="important_document_1">
              </div>
              <div class="document_content">
                <h3>Water for every acre of
                  agricultural land</h3>
                <p>The water challenge of the last half century has mainly led to development needs, Especially with
                  regard to reasonable and affordable access to drinking water The most urgent is related to the human
                  health crisis</p>
              </div>
              <div class="button_box" fxLayoutAlign="center center">
                <button class="btn btn-sm read-btn" mat-button
                  [routerLink]="['/government_offices_settings/irrigation_and_agriculture']">Read More</button>
              </div>
            </div>
            <!-- document_box -->
            <div class="document_box">
              <div class="document_img">
                <img src="../../../../../assets/images/100.png" alt="important_document_1">
              </div>
              <div class="document_content">
                <h3>100% ODF Village</h3>
                <p>This is a list of Indian states and territories ranked by their households with open defecation free
                  in both urban and rural areas. Figures are from the ministry of drinking water and sanitation. The
                  below table shows ODF( Open Defecation Free), households with Toilets as a percentage of the total
                  population..</p>
              </div>
              <div class="button_box" fxLayoutAlign="center center">
                <button class="btn btn-sm read-btn" mat-button
                  [routerLink]="['/government_offices_settings/sanitization']">Read More</button>
              </div>
            </div>
          </div>

        </div>
        <div class="model_village_sec" *ngIf="selectedLanguage==='te'">
          <div class="custom_heading">
            <h2 class="title">
              Narmetta as <span class="primary">Model Village</span>
            </h2>
          </div>
          <div class="model_village_banner">
            <video mute preload="auto" controls>
              <source src="../../../../../assets/images/Narmetta drone vedio (2019) before adoption.mp4"
                type="video/mp4">
            </video>
          </div>
          <div class="document_box_flex">
            <!-- document_box -->
            <div class="document_box">
              <div class="document_img">
                <img src="../../../../../assets/images/purified.png" alt="important_document_1">
              </div>
              <div class="document_content">
                <h3>శుద్ధి చేసిన తాగునీరు</h3>
                <p>పేద ప్రజల నీటి కొరత ప్రపంచవ్యాప్తంగా విస్తృతంగా గుర్తించబడిన దృగ్విషయం. ప్రపంచవ్యాప్తంగా ఒక బిలియన్
                  మందికి పైగా సురక్షితమైన, స్వచ్ఛమైన
                  తాగునీటిని పొందలేరని అంచనా వేయబడింది, అయినప్పటికీ ప్రాథమిక మానవ అవసరంగా ఇది జీవన హక్కు యొక్క
                  అంతర్భాగం..</p>
              </div>
              <div class="button_box" fxLayoutAlign="center center">
                <button class="btn btn-sm read-btn" mat-button
                  [routerLink]="['/government_offices_settings/community_water_supplys']">ఇంకా చదవండి</button>
              </div>
            </div>
            <!-- document_box -->
            <div class="document_box">
              <div class="document_img">
                <img src="../../../../../assets/images/water.png" alt="important_document_1">
              </div>
              <div class="document_content">
                <h3>వ్యవసాయ భూమిలోని ప్రతి ఎకరానికి నీరు</h3>
                <p>లోరెం ఇప్సమ్ యొక్క గద్యాలై అనేక వైవిధ్యాలు అందుబాటులో ఉన్నాయి,
                  కాని మెజారిటీ ఇంజెక్ట్ చేసిన హాస్యం ద్వారా ఏదో ఒక రూపంలో మార్పులను ఎదుర్కొంది.</p>
              </div>
              <div class="button_box" fxLayoutAlign="center center">
                <button class="btn btn-sm read-btn" mat-button
                  [routerLink]="['/government_offices_settings/irrigation_and_agriculture']">ఇంకా చదవండి</button>
              </div>
            </div>
            <!-- document_box -->
            <div class="document_box">
              <div class="document_img">
                <img src="../../../../../assets/images/odf.png" alt="important_document_1">
              </div>
              <div class="document_content">
                <h3>100% ODF గ్రామం</h3>
                <p>పట్టణ మరియు గ్రామీణ ప్రాంతాల్లో బహిరంగ మలవిసర్జన లేకుండా వారి గృహాలచే ర్యాంక్ చేయబడిన భారతీయ
                  రాష్ట్రాలు మరియు భూభాగాల జాబితా ఇది. గణాంకాలు తాగునీరు మరియు పారిశుద్ధ్య
                  మంత్రిత్వ శాఖ నుండి. దిగువ పట్టిక ODF (ఓపెన్ మలవిసర్జన ఉచిత), మొత్తం జనాభాలో ఒక శాతం మరుగుదొడ్లు ఉన్న
                  గృహాలను చూపిస్తుంది.</p>
              </div>
              <div class="button_box" fxLayoutAlign="center center">
                <button class="btn btn-sm read-btn" mat-button
                  [routerLink]="['/government_offices_settings/irrigation_and_agriculture']">ఇంకా చదవండి</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="document_pins_rightcolumn" fxLayout="column" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30"
        fxFlex.sm="100" fxFlex.xs="100" fxFlexFill>
        <div class="document_latest_sec">
          <div class="inner_title">
            <h2>Village Help Lines</h2>
          </div>
          <div class="document_latest_box" *ngIf="selectedLanguage==='en'">
            <div class="document_latest_img">
              <img src="../../../../../assets/images/village_help_lines.png" alt="">
            </div>
            <div class="document_latest_content">
              <ul class="helpline_list">
                <li>
                  <h5>State Control Room</h5>
                  <p>1070</p>
                </li>
                <li>
                  <h5>Police Control Room </h5>
                  <p>100</p>
                </li>
                <li>
                  <h5>Accident Help Line</h5>
                  <p>108</p>
                </li>
                <li>
                  <h5>Fire and Rescue</h5>
                  <p>101</p>
                </li>
                <li>
                  <h5>Ambulance Help Line</h5>
                  <p>102</p>
                </li>
                <li>
                  <h5>Child Help line</h5>
                  <p>1098</p>
                </li>
                <li>
                  <h5>Disaster HelpLine </h5>
                  <p>1077</p>
                </li>
                <li class="lines">
                  <h5>Sexual Harassment</h5>
                  <p>1091</p>
                </li>
              </ul>
            </div>
          </div>

          <div class="document_latest_box" *ngIf="selectedLanguage==='te'">
            <div class="document_latest_img">
              <img src="../../../../../assets/images/village_help_lines.png" alt="">
            </div>
            <div class="document_latest_content">
              <ul class="helpline_list">
                <li>
                  <h5>రాష్ట్ర నియంత్రణ గది</h5>
                  <p>1070</p>
                </li>
                <li>
                  <h5>పోలీస్ కంట్రోల్ రూమ్ </h5>
                  <p>100</p>
                </li>
                <li>
                  <h5>యాక్సిడెంట్ హెల్ప్ లైన్</h5>
                  <p>108</p>
                </li>
                <li>
                  <h5>ఫైర్ అండ్ రెస్క్యూ</h5>
                  <p>101</p>
                </li>
                <li>
                  <h5>అంబులెన్స్ హెల్ప్ లైన్</h5>
                  <p>102</p>
                </li>
                <li>
                  <h5>చైల్డ్ హెల్ప్‌లైన్</h5>
                  <p>1098</p>
                </li>
                <li>
                  <h5>డిజాస్టర్ హెల్ప్ లైన్ </h5>
                  <p>1077</p>
                </li>
                <li class="lines">
                  <h5>లైంగిక వేధింపులు</h5>
                  <p>1091</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="adrash-gram">

  <div class="custom_heading">
    <P>MODEL VILLAGE</P>
    <h2>
      STEPS TO BECOME ADARSH GRAM
    </h2>
  </div>
  <div class="wrapper">
    <div class="model_village_sec" *ngIf="selectedLanguage==='en'">
      <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column"
        fxLayoutAlign="center center" fxLayoutGap="30px">
        <div fxLayout="column" fxFlex.xl="33" fxFlex.lg="33" fxFlex.md="33" fxFlex.sm="50" fxFlex.xs="100" fxFlexFill>
          <div class="steps" fxLayoutAlign="center center">
            <div class="step-img">
              <img src="../../../../../assets/images/ic/icons/emploment.svg">
            </div>
            <div class="step-conent">
              <h6>Identify people's needs and Priorties</h6>
              <h6>(food ,shelter,health,Education and Employment)</h6>
            </div>
          </div>
          <div class="steps" fxLayoutAlign="center center">
            <div class="step-img">
              <img src="../../../../../assets/images/ic/icons/elecrcity.svg">
            </div>
            <div class="step-conent">
              <h6>Repair and renovate existing infrastrutre</h6>
            </div>
          </div>
          <div class="steps" fxLayoutAlign="center center">
            <div class="step-img">
              <img src="../../../../../assets/images/ic/icons/000000ff.svg">
            </div>
            <div class="step-conent">
              <h6>Electricity:New and reewable energy</h6>
            </div>
          </div>
          <div class="steps" fxLayoutAlign="center center">
            <div class="step-img">
              <img src="../../../../../assets/images/ic/icons/sanstaion.svg">
            </div>
            <div class="step-conent">
              <h6>Sanitation: Cleanless under swatch bharath Abhilyam ,public Toilets</h6>
            </div>
          </div>

        </div>
        <div fxLayout="column" fxFlex.xl="33" fxFlex.lg="33" fxFlex.md="33" fxFlex.sm="50" fxFlex.xs="100" fxFlexFill>
          <div class="steps" fxLayoutAlign="center center">
            <div class="step-img">
              <img src="../../../../../assets/images/ic/icons/comminty.svg">
            </div>
            <div class="step-conent">
              <h6>Define activitices that can mobilize the complete community</h6>
            </div>
          </div>
          <div class="steps" fxLayoutAlign="center center">
            <div class="step-img">
              <img src="../../../../../assets/images/ic/icons/education.svg">
            </div>
            <div class="step-conent">
              <h6>Education infrastrutre provsion of good and value education</h6>
            </div>
          </div>
          <div class="steps" fxLayoutAlign="center center">
            <div class="step-img">
              <img src="../../../../../assets/images/ic/icons/hotstop.png">
            </div>
            <div class="step-conent">
              <h6>Mobility&Commucation:mobile tower ,wifi,It hub</h6>
            </div>
          </div>
          <div class="steps" fxLayoutAlign="center center">
            <div class="step-img">
              <img src="../../../../../assets/images/ic/icons/water.svg">
            </div>
            <div class="step-conent">
              <h6>Water faclities : safe driniking water and water for crops</h6>
            </div>
          </div>
        </div>
        <div fxLayout="column" fxFlex.xl="33" fxFlex.lg="33" fxFlex.md="33" fxFlex.sm="50" fxFlex.xs="100" fxFlexFill>
          <div class="steps" fxLayoutAlign="center center">
            <div class="step-img">
              <img src="../../../../../assets/images/ic/icons/govement house.svg">
            </div>
            <div class="step-conent">
              <h6>Use resources for running goverment schemes</h6>
            </div>
          </div>
          <div class="steps" fxLayoutAlign="center center">
            <div class="step-img">
              <img src="../../../../../assets/images/ic/icons/commity.svg">
            </div>
            <div class="step-conent">
              <h6>Promote Transparencey and accountablity</h6>
            </div>
          </div>
          <div class="steps" fxLayoutAlign="center center">
            <div class="step-img">
              <img src="../../../../../assets/images/ic/icons/medical.svg">
            </div>
            <div class="step-conent">
              <h6>Health care :health sub Center and ambulance</h6>
            </div>
          </div>
          <div class="steps" fxLayoutAlign="center center">
            <div class="step-img">
              <img src="../../../../../assets/images/ic/icons/argicluture.png">
            </div>
            <div class="step-conent">
              <h6>Agriculture :organic agriculutre and traning and counseling for framers</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="model_village_sec" *ngIf="selectedLanguage==='te'">
    <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column"
      fxLayoutAlign="center center" fxLayoutGap="30px">
      <div fxLayout="column" fxFlex.xl="33" fxFlex.lg="33" fxFlex.md="33" fxFlex.sm="50" fxFlex.xs="100" fxFlexFill>
        <div class="steps" fxLayoutAlign="center center">
          <div class="step-img">
            <img src="../../../../../assets/images/ic/icons/emploment.svg">
          </div>
          <div class="step-conent">
            <h6>ప్రజల అవసరాలు మరియు ప్రాధాన్యతలను గుర్తించండి</h6>
            <h6>(ఆహారం, ఆశ్రయం, ఆరోగ్యం, విద్య మరియు ఉపాధి)</h6>
          </div>
        </div>
        <div class="steps" fxLayoutAlign="center center">
          <div class="step-img">
            <img src="../../../../../assets/images/ic/icons/elecrcity.svg">
          </div>
          <div class="step-conent">
            <h6>ఇప్పటికే ఉన్న ఇన్‌ఫ్రాస్ట్రూటర్‌ను రిపేర్ చేయండి మరియు పునరుద్ధరించండి</h6>
          </div>
        </div>
        <div class="steps" fxLayoutAlign="center center">
          <div class="step-img">
            <img src="../../../../../assets/images/ic/icons/000000ff.svg">
          </div>
          <div class="step-conent">
            <h6>విద్యుత్: కొత్త మరియు పునరుత్పాదక శక్తి</h6>
          </div>
        </div>
        <div class="steps" fxLayoutAlign="center center">
          <div class="step-img">
            <img src="../../../../../assets/images/ic/icons/sanstaion.svg">
          </div>
          <div class="step-conent">
            <h6>పారిశుధ్యం: స్వచ్ఛభారత్ అభిలయం, పబ్లిక్ టాయిలెట్స్ కింద శుభ్రంగా ఉంది</h6>
          </div>
        </div>

      </div>
      <div fxLayout="column" fxFlex.xl="33" fxFlex.lg="33" fxFlex.md="33" fxFlex.sm="50" fxFlex.xs="100" fxFlexFill>
        <div class="steps" fxLayoutAlign="center center">
          <div class="step-img">
            <img src="../../../../../assets/images/ic/icons/comminty.svg">
          </div>
          <div class="step-conent">
            <h6>పూర్తి సంఘాన్ని సమీకరించగల కార్యకలాపాలను నిర్వచించండి</h6>
          </div>
        </div>
        <div class="steps" fxLayoutAlign="center center">
          <div class="step-img">
            <img src="../../../../../assets/images/ic/icons/education.svg">
          </div>
          <div class="step-conent">
            <h6>మంచి మరియు విలువలతో కూడిన విద్య యొక్క మౌలిక సదుపాయాల విద్య</h6>
          </div>
        </div>
        <div class="steps" fxLayoutAlign="center center">
          <div class="step-img">
            <img src="../../../../../assets/images/ic/icons/hotstop.png">
          </div>
          <div class="step-conent">
            <h6>మొబిలిటీ & కమ్యూనికేషన్: మొబైల్ టవర్, వైఫై, ఇట్ హబ్</h6>
          </div>
        </div>
        <div class="steps" fxLayoutAlign="center center">
          <div class="step-img">
            <img src="../../../../../assets/images/ic/icons/water.svg">
          </div>
          <div class="step-conent">
            <h6>నీటి సౌలభ్యం: పంటలకు సురక్షితమైన త్రాగునీరు మరియు నీరు</h6>
          </div>
        </div>
      </div>
      <div fxLayout="column" fxFlex.xl="33" fxFlex.lg="33" fxFlex.md="33" fxFlex.sm="50" fxFlex.xs="100" fxFlexFill>
        <div class="steps" fxLayoutAlign="center center">
          <div class="step-img">
            <img src="../../../../../assets/images/ic/icons/govement house.svg">
          </div>
          <div class="step-conent">
            <h6>ప్రభుత్వ పథకాలను అమలు చేయడానికి వనరులను ఉపయోగించండి</h6>
          </div>
        </div>
        <div class="steps" fxLayoutAlign="center center">
          <div class="step-img">
            <img src="../../../../../assets/images/ic/icons/commity.svg">
          </div>
          <div class="step-conent">
            <h6>పారదర్శకత మరియు అకౌంటబిలిటీని ప్రోత్సహించండి</h6>
          </div>
        </div>
        <div class="steps" fxLayoutAlign="center center">
          <div class="step-img">
            <img src="../../../../../assets/images/ic/icons/medical.svg">
          </div>
          <div class="step-conent">
            <h6>ఆరోగ్య సంరక్షణ: ఆరోగ్య ఉప కేంద్రం మరియు అంబులెన్స్</h6>
          </div>
        </div>
        <div class="steps" fxLayoutAlign="center center">
          <div class="step-img">
            <img src="../../../../../assets/images/ic/icons/argicluture.png">
          </div>
          <div class="step-conent">
            <h6>వ్యవసాయం: సేంద్రీయ వ్యవసాయం మరియు ఫ్రేమర్‌లకు ట్రాన్సింగ్ మరియు కౌన్సెలింగ్</h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="histoc">
  <div class="custom_heading">
    <h2>
      Historic places
    </h2>
  </div>
  <div class="wrapper">
  <div class="members" *ngIf="selectedLanguage==='en'">
   
        <div  fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
          fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="10px">
          <div fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="50" fxFlex.xs="100" fxFlexFill
            fxLayoutAlign="center flex-end">
            <div>
              <img src="../../../../../assets/images/1 (1).png" alt="img">
            </div>
          </div>
          <div fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="50" fxFlex.xs="100" fxFlexFill>
            <h1>Adimanavula gundu</h1>

            <p>These historic places of the village have been renovated and made visiting places of the district thereby
              promoting tourists. </p>
          </div>
        </div>
        <div class="sec-margin-b" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
          fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="10px">
          <div fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="50" fxFlex.xs="100" fxFlexFill
            fxLayoutAlign="center">

            <h1>Buruju</h1>

            <p>These historic places of the village have been renovated and made visiting places of the district thereby
              promoting tourism</p>

          </div>
          <div  class="hos"fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="50" fxFlex.xs="100" fxFlexFill>
            <div>
              <img src="../../../../../assets/images/Ellipse 30.png" alt="img">
            </div>
          </div>
        </div>
    </div>
    <div class="members" *ngIf="selectedLanguage==='te'">
   
      <div  fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
        fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="10px">
        <div fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="50" fxFlex.xs="100" fxFlexFill
          fxLayoutAlign="center flex-end">
          <div>
            <img src="../../../../../assets/images/1 (1).png" alt="img">
          </div>
        </div>
        <div fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="50" fxFlex.xs="100" fxFlexFill>
          <h1>ఆదిమానవుల గుండు</h1>

          <p>గ్రామంలోని ఈ చారిత్రాత్మక ప్రదేశాలు పునర్నిర్మించబడ్డాయి మరియు జిల్లాలోని సందర్శనా స్థలాలుగా పర్యాటకులను ప్రోత్సహిస్తాయి. </p>
        </div>
      </div>
      <div class="sec-margin-b" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
        fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="10px">
        <div fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="50" fxFlex.xs="100" fxFlexFill
          fxLayoutAlign="center">

          <h1>బుర్జ్</h1>

          <p>గ్రామంలోని ఈ చారిత్రాత్మక ప్రదేశాలు పునర్నిర్మించబడ్డాయి మరియు తద్వారా జిల్లాలోని సందర్శనా స్థలాలుగా మార్చబడ్డాయి
            పర్యాటకాన్ని ప్రోత్సహించడం</p>

        </div>
        <div  class="hos"fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="50" fxFlex.xs="100" fxFlexFill>
          <div>
            <img src="../../../../../assets/images/Ellipse 30.png" alt="img">
          </div>
        </div>
      </div>
  </div>
    </div>
</section>
<!-- Progressive Initiatives -->
<section class="innerpage_sec navigations">
  <div class="custom_heading">
    <p>Narmetta</p>
    <h2>
      PROGRESSIVE INITIATIVES</h2>
  </div>
  <div class="wrapper">
    <div class="swiper-button-prev initiatives-button-prev">
      <img src="../../../../../assets/images/ic/left-arrow.svg" alt="" srcset="">
    </div>
    <div class="swiper-container" [swiper]="config" *ngIf="selectedLanguage==='en'">


      <div class="swiper-wrapper">
        <!-- FIRST -->
        <div class="swiper-slide">
          <div class="card_box">
            <div class="card_img">
              <img src="../../../../../assets/images/progressive/devloper.jpeg">
            </div>
            <div class="card_conent">
              <h5 [routerLink]="['/initiatives_settings/various_development_works_status']"> Various Devlopment works
              </h5>
            </div>
          </div>
          <div class="overlay"></div>
        </div>
        <div class="swiper-slide">
          <div class="card_box">
            <div class="card_img">
              <img src="../../../../../assets/images/INITIATIVES/empower.jpg">
            </div>
            <div class="card_conent">
              <h5 [routerLink]="['/initiatives_settings/cooperative_societies']">Cooperative Societies</h5>
            </div>
          </div>
          <div class="overlay"></div>
        </div>
        <div class="swiper-slide">
          <div class="card_box">
            <div class="card_img">
              <img src="../../../../../assets/images/tranditonal/parks.jpg">
            </div>
            <div class="card_conent">
              <h5 [routerLink]="['/initiatives_settings/sports_development']">Sports Development</h5>
            </div>
          </div>
          <div class="overlay"></div>
        </div>
        <div class="swiper-slide">
          <div class="card_box">
            <div class="card_img">
              <img src="../../../../../assets/images/INITIATIVES/youth.jpg">
            </div>
            <div class="card_conent">
              <h5 [routerLink]="['/initiatives_settings/youth_empowerment']">Youth Empowerment</h5>
            </div>
          </div>
          <div class="overlay"></div>
        </div>
        <div class="swiper-slide">
          <div class="card_box">
            <div class="card_img">
              <img src="../../../../../assets/images/INITIATIVES/Personality Development.jpg">
            </div>
            <div class="card_conent">
              <h5 [routerLink]="['/initiatives_settings/support_for_farming_sector']">Support for Farming Sector</h5>
            </div>
          </div>
          <div class="overlay"></div>
        </div>
        <div class="swiper-slide">
          <div class="card_box">
            <div class="card_img">
              <img src="../../../../../assets/images/INITIATIVES/Talent Management among Kids.jpg">
            </div>
            <div class="card_conent">
              <h5 [routerLink]="['/initiatives_settings/students_empowerment']">Students Empowerment</h5>
            </div>
          </div>
          <div class="overlay"></div>
        </div>
        <div class="swiper-slide">
          <div class="card_box">
            <div class="card_img">
              <img src="../../../../../assets/images/INITIATIVES/fit village.jpg">
            </div>
            <div class="card_conent">
              <h5 [routerLink]="['/initiatives_settings/fit_village']">Fit Village</h5>
            </div>
          </div>
          <div class="overlay"></div>
        </div>
        <div class="swiper-slide">
          <div class="card_box">
            <div class="card_img">
              <img src="../../../../../assets/images/INITIATIVES/computer education.png">
            </div>
            <div class="card_conent">
              <h5 [routerLink]="['/initiatives_settings/computer_education']">Computer Education</h5>
            </div>
          </div>
          <div class="overlay"></div>
        </div>
      </div>

    </div>
    <div class="swiper-container" [swiper]="config" *ngIf="selectedLanguage==='te'">


      <div class="swiper-wrapper">
        <!-- FIRST -->
        <div class="swiper-slide">
          <div class="card_box">
            <div class="card_img">
              <img src="../../../../../assets/images/progressive/devloper.jpeg">
            </div>
            <div class="card_conent">
              <h5 [routerLink]="['/initiatives_settings/various_development_works_status']"> వివిధ అభివృద్ధి పనులు
              </h5>
            </div>
          </div>
          <div class="overlay"></div>
        </div>
        <div class="swiper-slide">
          <div class="card_box">
            <div class="card_img">
              <img src="../../../../../assets/images/INITIATIVES/empower.jpg">
            </div>
            <div class="card_conent">
              <h5 [routerLink]="['/initiatives_settings/cooperative_societies']">సహకార సంఘాలు</h5>
            </div>
          </div>
          <div class="overlay"></div>
        </div>
        <div class="swiper-slide">
          <div class="card_box">
            <div class="card_img">
              <img src="../../../../../assets/images/tranditonal/parks.jpg">
            </div>
            <div class="card_conent">
              <h5 [routerLink]="['/initiatives_settings/sports_development']">క్రీడల అభివృద్ధి</h5>
            </div>
          </div>
          <div class="overlay"></div>
        </div>
        <div class="swiper-slide">
          <div class="card_box">
            <div class="card_img">
              <img src="../../../../../assets/images/INITIATIVES/youth.jpg">
            </div>
            <div class="card_conent">
              <h5 [routerLink]="['/initiatives_settings/youth_empowerment']">యువత సాధికారత</h5>
            </div>
          </div>
          <div class="overlay"></div>
        </div>
        <div class="swiper-slide">
          <div class="card_box">
            <div class="card_img">
              <img src="../../../../../assets/images/INITIATIVES/Personality Development.jpg">
            </div>
            <div class="card_conent">
              <h5 [routerLink]="['/initiatives_settings/support_for_farming_sector']">వ్యవసాయ రంగానికి మద్దతు</h5>
            </div>
          </div>
          <div class="overlay"></div>
        </div>
        <div class="swiper-slide">
          <div class="card_box">
            <div class="card_img">
              <img src="../../../../../assets/images/INITIATIVES/Talent Management among Kids.jpg">
            </div>
            <div class="card_conent">
              <h5 [routerLink]="['/initiatives_settings/students_empowerment']">విద్యార్థుల సాధికారత</h5>
            </div>
          </div>
          <div class="overlay"></div>
        </div>
        <div class="swiper-slide">
          <div class="card_box">
            <div class="card_img">
              <img src="../../../../../assets/images/INITIATIVES/fit village.jpg">
            </div>
            <div class="card_conent">
              <h5 [routerLink]="['/initiatives_settings/fit_village']">ఫిట్ విలేజ్</h5>
            </div>
          </div>
          <div class="overlay"></div>
        </div>
        <div class="swiper-slide">
          <div class="card_box">
            <div class="card_img">
              <img src="../../../../../assets/images/INITIATIVES/computer education.png">
            </div>
            <div class="card_conent">
              <h5 [routerLink]="['/initiatives_settings/computer_education']">కంప్యూటర్ విద్య</h5>
            </div>
          </div>
          <div class="overlay"></div>
        </div>
      </div>

    </div>
    <div class="swiper-button-next initiatives-button-next">
      <img src="../../../../../assets/images/ic/right-arrow.svg" alt="" srcset="">
    </div>
    <div class="custom_heading">
      <h2>
      </h2>
    </div>
  </div>
</section>
<section class="nar-map">
  <div class="custom_heading">
    <p>Narmetta</p>
    <h2>NARMETTA VILLAGE MAP</h2>
  </div>
  <div class="wrapper">
    <div class="route">
      <img src="../../../../../assets/images/map.PNG">
    </div>
  </div>
</section>
<section class="oraganic">
  <div class="custom_heading">
    <h2> Organic Farming</h2>
  </div>
  <div class="wrapper">
    <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column"
      fxLayoutAlign="center center" fxLayoutGap="10px">
      <div class="organic-video" fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="50"
        fxFlex.xs="100" fxFlexFill fxLayoutAlign="center flex-start">
        <video  autoplay controls>
          <source
            src="../../../../../assets/images/oragic/Dr Lion Kiron Kumar MD, Suchirindia Introduces Biocapsules for Organic Farming __ Hybiz tv.mp4"
            type="video/mp4">
        </video>
      </div>
      <div fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="50" fxFlex.xs="100"
        fxLayoutAlign="center flex-start">
        <div class="oraginc-img" fxLayout="row" fxLayout.xs="column" fxLayoutGap="10px">
          <div fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="100" fxFlex.xs="100">
            <img src="../../../../../assets/images/oragic/4.jpeg">
          </div>
          <div fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="100" fxFlex.xs="100">
            <img src="../../../../../assets/images/oragic/2.jpeg">
          </div>
        </div>
        <!-- <div class="oraginc-img" fxLayout="row" fxLayout.xs="column"fxLayoutGap="10px">
        <div fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="100" fxFlex.xs="100">
          <img src="../../../../../assets/images/oragic/4.jpeg">
        </div>
        <div fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="100" fxFlex.xs="100">
          <img src="../../../../../assets/images/oragic/5.jpeg">
        </div>
        </div> -->
      </div>
    </div>
    <div class="bunton" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
      fxLayout.xs="column" fxLayoutAlign="center center">
      <button class="btn btn-sm read-btn" mat-button [routerLink]="['/village_video_items']">Read More</button>
    </div>
  </div>
</section>
<section class="innerpage_sec">
  <div class="custom_heading">
    <p>Narmetta</p>
    <h2>GOVERNMENT OFFICIES</h2>
  </div>
  <div class="wrapper">
    <div fxLayout="row" fxLayout.xs="column">

      <div class="govn_box_flex" *ngIf="selectedLanguage==='te'">
        <!-- document_box -->
        <!-- <div fxLayout="column" fxFlex.xl="33" fxFlex.lg="33" fxFlex.md="33" fxFlex.sm="50" fxFlex.xs="100"> -->
        <div class="govn_box">
          <div class="govn_img">
            <img src="../../../../../assets/images/progressive/GP.jpeg" alt="important_document_1">
          </div>
          <div class="govn_content">
            <h3>గ్రామపంచాయతీ</h3>

            <button class="btn btn-sm read-btn" mat-button
              [routerLink]="['/government_offices_settings/grampanchayat']">ఇంకా చదవండి</button>
          </div>
        </div>
        <!-- </div> -->
        <!-- <div fxLayout="column" fxFlex.xl="33" fxFlex.lg="33" fxFlex.md="33" fxFlex.sm="50" fxFlex.xs="100"> -->
        <div class="govn_box">
          <div class="govn_img">
            <img src="../../../../../assets/images/progressive/20201116_161932.jpg" alt="important_document_1">
          </div>
          <div class="govn_content">
            <h3>ప్రాథమిక ఆరోగ్య సంరక్షణ కేంద్రం</h3>
            <button class="btn btn-sm read-btn" mat-button
              [routerLink]="['/government_offices_settings/primary_healthcare_center']">ఇంకా చదవండి</button>
          </div>
        </div>
        <!-- </div>
      <div fxLayout="column" fxFlex.xl="33" fxFlex.lg="33" fxFlex.md="33" fxFlex.sm="50" fxFlex.xs="100"> -->
        <div class="govn_box">
          <div class="govn_img">
            <img src="../../../../../assets/images/progressive/Anganwadi centre.jpeg" alt="important_document_1">
          </div>
          <div class="govn_content">
            <h3>అంగన్‌వాడీ కేంద్రం</h3>
            <button class="btn btn-sm read-btn" mat-button
              [routerLink]="['/government_offices_settings/anganwadi_centers']">ఇంకా చదవండి</button>
          </div>
        </div>
      </div>
      <div class="govn_box_flex" *ngIf="selectedLanguage==='en'">
        <!-- document_box -->
        <!-- <div fxLayout="column" fxFlex.xl="33" fxFlex.lg="33" fxFlex.md="33" fxFlex.sm="50" fxFlex.xs="100"> -->
        <div class="govn_box">
          <div class="govn_img">
            <img src="../../../../../assets/images/progressive/GP.jpeg" alt="important_document_1">
          </div>
          <div class="govn_content">
            <h3>Grampanchayat</h3>

            <button class="btn btn-sm read-btn" mat-button
              [routerLink]="['/government_offices_settings/grampanchayat']">Read More</button>
          </div>
        </div>
        <!-- </div> -->
        <!-- <div fxLayout="column" fxFlex.xl="33" fxFlex.lg="33" fxFlex.md="33" fxFlex.sm="50" fxFlex.xs="100"> -->
        <div class="govn_box">
          <div class="govn_img">
            <img src="../../../../../assets/images/progressive/20201116_161932.jpg" alt="important_document_1">
          </div>
          <div class="govn_content">
            <h3>Primary Health Care Center</h3>
            <button class="btn btn-sm read-btn" mat-button
              [routerLink]="['/government_offices_settings/primary_healthcare_center']">Read More</button>
          </div>
        </div>
        <!-- </div>
      <div fxLayout="column" fxFlex.xl="33" fxFlex.lg="33" fxFlex.md="33" fxFlex.sm="50" fxFlex.xs="100"> -->
        <div class="govn_box">
          <div class="govn_img">
            <img src="../../../../../assets/images/progressive/Anganwadi centre.jpeg" alt="important_document_1">
          </div>
          <div class="govn_content">
            <h3>Anganwadi Center</h3>
            <button class="btn btn-sm read-btn" mat-button
              [routerLink]="['/government_offices_settings/anganwadi_centers']">Read More</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</section>

<!-- <app-progressive-initiatives></app-progressive-initiatives>
<app-villlage-governance-offices></app-villlage-governance-offices> -->
<!-- Village Vision Narmetta -->
<section class="village_vision_sec">
  <!-- <div class="vision_right"></div> -->
  <!-- <div class="vision_left"></div>
  <div class="vision_bottom_right"></div> -->
  <div class="wrapper">

    <div class="village_vision_row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
      fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="20px" *ngIf="selectedLanguage==='en'">

      <div class="village_vision_column" fxLayout="column" fxFlex.xl="70" fxFlex.lg="70" fxFlex.md="70" fxFlex.sm="100"
        fxFlex.xs="100" fxFlexFill>
        <div class="Vision_banner">
          <img src="../../../../../assets/images/ceo sir at Buruju.jpeg" alt="progressive_initiatives">

          <div class="content">
            <h2>Vision of narmetta </h2>
            <p>Narmetta village aims to maximize opportunities for social and economic development, while retaining
              ecological sanctity sustainability , harmony , and participation of communities. Narmaetta grampanchayat
              intends to become one of the unique model villages across Telengana state</p>
            <button class="btn btn-sm read-btn" mat-button [routerLink]="['/About/vision']">Read More</button>
          </div>
        </div>
      </div>
      <div class="village_vision_column public_places_column" fxLayout="column" fxFlex.xl="30" fxFlex.lg="30"
        fxFlex.md="30" fxFlex.sm="100" fxFlex.xs="100" fxFlexFill>
        <div class="place_box">
          <div class="public_places_head">
            <h4>PROMINENT PUBLIC PLACES</h4>
          </div>
          <div class="wrapper">
            <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
              fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="50px" id="directors">
              <div fxLayout="column" fxFlex.xl="60" fxFlex.lg="60" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="100"
                fxFlexFill>

                <div class="media">
                  <img src="../../../../../assets/images/tranditonal/Mosques.jpg" alt="img">
                </div>
              </div>
              <div fxLayout="column" fxFlex.xl="40" fxFlex.lg="40" fxFlex.md="40" fxFlex.sm="50" fxFlex.xs="100"
                fxFlexFill>
                <div class="media-bodys">
                  <h1>MOSQUES</h1>
                  <button class="btn btn-sm read-btn" mat-button [routerLink]="['/public_places_settings/mosques']">Read
                    More</button>
                </div>
              </div>
            </div>
            <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
              fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="50px" id="directors">
              <div fxLayout="column" fxFlex.xl="40" fxFlex.lg="40" fxFlex.md="40" fxFlex.sm="50" fxFlex.xs="100"
                fxFlexFill fxLayoutAlign="center flex-end">
                <div class="media-body">
                  <h1>CHURUCHES</h1>
                  <button class="btn btn-sm read-btn" mat-button
                    [routerLink]="['/public_places_settings/churches']">Read More</button>

                </div>
              </div>
              <div fxLayout="column" fxFlex.xl="60" fxFlex.lg="60" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="100"
                fxFlexFill>
                <div class="media">
                  <img src="../../../../../assets/images/tranditonal/Churches.jpg" alt="img">
                </div>
              </div>
            </div>
            <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
              fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="50px" id="directors">
              <div fxLayout="column" fxFlex.xl="60" fxFlex.lg="60" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="100"
                fxFlexFill>

                <div class="media">
                  <img src="../../../../../assets/images/tranditonal/Temples.jpg" alt="img">
                </div>
              </div>
              <div fxLayout="column" fxFlex.xl="40" fxFlex.lg="40" fxFlex.md="40" fxFlex.sm="50" fxFlex.xs="100"
                fxFlexFill>
                <div class="media-bods">
                  <h1>Temples</h1>
                  <button class="btn btn-sm read-btn" mat-button [routerLink]="['/public_places_settings/temples']">Read
                    More</button>
                </div>
              </div>
            </div>
            <button class="btn btn-sm read-btn" mat-button [routerLink]="['/public_places_settings']">View all</button>
          </div>

        </div>
      </div>
    </div>
    <div class="village_vision_row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
      fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="20px" *ngIf="selectedLanguage==='te'">

      <div class="village_vision_column" fxLayout="column" fxFlex.xl="70" fxFlex.lg="70" fxFlex.md="70" fxFlex.sm="100"
        fxFlex.xs="100" fxFlexFill>
        <div class="Vision_banner">
          <img src="../../../../../assets/images/ceo sir at Buruju.jpeg" alt="progressive_initiatives">

          <div class="content">
            <h2>నార్మెట్ట దర్శనం </h2>
            <p>నర్మెట్ట గ్రామం నిలుపుకుంటూనే సామాజిక మరియు ఆర్థిక అభివృద్ధికి అవకాశాలను పెంచుకోవడం లక్ష్యంగా పెట్టుకుంది
              పర్యావరణ పవిత్రత స్థిరత్వం, సామరస్యం మరియు సంఘాల భాగస్వామ్యం. నర్మఎట్ట గ్రామపంచాయతీ
              తెలంగాణ రాష్ట్రవ్యాప్తంగా ఉన్న ఏకైక మోడల్ గ్రామాలలో ఒకటిగా మారాలని భావిస్తోంది</p>
            <button class="btn btn-sm read-btn" mat-button [routerLink]="['/About/vision']">ఇంకా చదవండి</button>
          </div>
        </div>
      </div>
      <div class="village_vision_column public_places_column" fxLayout="column" fxFlex.xl="30" fxFlex.lg="30"
        fxFlex.md="30" fxFlex.sm="100" fxFlex.xs="100" fxFlexFill>
        <div class="place_box">
          <div class="public_places_head">
            <h4>ప్రముఖ పబ్లిక్ స్థలాలు</h4>
          </div>
          <div class="wrapper">
            <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
              fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="50px" id="directors">
              <div fxLayout="column" fxFlex.xl="60" fxFlex.lg="60" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="100"
                fxFlexFill>

                <div class="media">
                  <img src="../../../../../assets/images/tranditonal/Mosques.jpg" alt="img">
                </div>
              </div>
              <div fxLayout="column" fxFlex.xl="40" fxFlex.lg="40" fxFlex.md="40" fxFlex.sm="50" fxFlex.xs="100"
                fxFlexFill>
                <div class="media-bodys">
                  <h1>మసీదులు</h1>
                  <button class="btn btn-sm read-btn" mat-button [routerLink]="['/public_places_settings/mosques']">ఇంకా చదవండి</button>
                </div>
              </div>
            </div>
            <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
              fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="50px" id="directors">
              <div fxLayout="column" fxFlex.xl="40" fxFlex.lg="40" fxFlex.md="40" fxFlex.sm="50" fxFlex.xs="100"
                fxFlexFill fxLayoutAlign="center flex-end">
                <div class="media-body">
                  <h1>చర్చిలు</h1>
                  <button class="btn btn-sm read-btn" mat-button
                    [routerLink]="['/public_places_settings/churches']">ఇంకా చదవండి</button>

                </div>
              </div>
              <div fxLayout="column" fxFlex.xl="60" fxFlex.lg="60" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="100"
                fxFlexFill>
                <div class="media">
                  <img src="../../../../../assets/images/tranditonal/Churches.jpg" alt="img">
                </div>
              </div>
            </div>
            <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
              fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="50px" id="directors">
              <div fxLayout="column" fxFlex.xl="60" fxFlex.lg="60" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="100"
                fxFlexFill>

                <div class="media">
                  <img src="../../../../../assets/images/tranditonal/Temples.jpg" alt="img">
                </div>
              </div>
              <div fxLayout="column" fxFlex.xl="40" fxFlex.lg="40" fxFlex.md="40" fxFlex.sm="50" fxFlex.xs="100"
                fxFlexFill>
                <div class="media-bods">
                  <h1>Temples</h1>
                  <button class="btn btn-sm read-btn" mat-button [routerLink]="['/public_places_settings/temples']">ఇంకా చదవండి</button>
                </div>
              </div>
            </div>
            <button class="btn btn-sm read-btn" mat-button [routerLink]="['/public_places_settings']">View all</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>
<!-- Weekly Newsletter -->
<!-- <section class="weekly_newsletter">
    <div class="wrapper">
      <div class="newsletter_banner">
        <img src="../../../../../assets/images/weekly_newslatter.png" alt="weekly_newsletter">
        <div class="banner_container">
          <div class="content">
            <h2>Weekly Newsletter</h2>
            <p>Connect with weekly newsletter.</p>
            <form class="form-section footer-notify-input" [formGroup]="subscriptionForm" #subscriptionFormRef
              (ngSubmit)="addNewsLetterSubscription()">
              <div class="custom-form-group">
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="Enter Your Email Id" formControlName="email">
                  </mat-form-field>
                </div>
                <button type="submit" class="btn btn-sm newsletter_btn icon-btn" mat-button>Subscribe</button>
              </div>
            </form>
          </div>
        </div>
        <div class="banner_overlay"></div>
      </div>
    </div>
  </section> -->

<!-- Latest Photo / Event Galleries -->
<section class="latest_photo_sec">
  <!-- <div class="photo_overlay_center"></div>
  <div class="photo_overlay_right"></div> -->
  <div class="wrapper">
    <div class="latest_photo_row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
      fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
      <div class="latest_photo_column left" fxLayout="column" fxFlex.xl="70" fxFlex.lg="70" fxFlex.md="70"
        fxFlex.sm="100" fxFlex.xs="100" fxFlexFill *ngIf="villageVideoItems">
        <!-- <div class="custom_heading">
          <h2 class="title">
            <span class="primary">Latest Event Videos </span>
          </h2>
          <button class="btn btn-sm view-btn" mat-button routerLink="/village_video_items"
            queryParamsHandling="merge">View All</button>
        </div> -->
        <!-- <div class="galleries_banner">

          <div class="galleries_box">
            <div class="gallery_img">
              <video [src]="villageVideoItems[0].video.url" alt="latest_photo_event_galleries" controls></video>
            </div>
          </div> -->
        <!-- 
          <div class="galleries_box">
            <div class="gallery_img">
              <video [src]="villageVideoItems[1].video.url" alt="latest_photo_event_galleries" controls></video>
            </div>
          </div> -->

        <!-- </div> -->
        <!-- <div class="gallery_list" *ngIf="eventsSettings">
          <ul>
            <li>
              <div [ngStyle]="{'background-image':'url('+eventsSettings.religious_celebrations.image.url+')'}"
                class="gallery_bg_img">
                <a [routerLink]="['../', eventsSettings.religious_celebrations.en_title]" queryParamsHandling="merge">
                  <div class="card_img">
                    <img src="../../../../../assets/images/village_exhibition_center.png" alt="">
                    <h5 [innerHtml]="eventsSettings.religious_celebrations.en_title"> </h5>
                  </div>
                </a>
              </div>
            </li>
            <li>
              <div [ngStyle]="{'background-image':'url('+eventsSettings.melas_or_jataras.image.url+')'}"
                class="gallery_bg_img">
                <a [routerLink]="['../', eventsSettings.melas_or_jataras.en_title]" queryParamsHandling="merge">
                  <div class="card_img">
                    <img src="../../../../../assets/images/village_exhibition_center.png" alt="">
                    <h5 [innerHtml]="eventsSettings.melas_or_jataras.en_title"> </h5>
                  </div>
                </a>
              </div>
            </li>
          </ul>
        </div>-->
        <div>






        </div>
      </div>

      <div class="latest_photo_column right" fxLayout="column" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="40"
        fxFlex.sm="100" fxFlex.xs="100" fxFlexFill>
        <div class="feed-iframe-box">
          <div class="feed-head">
            <div>
              <img src="../../../../../assets/images/facebook.svg" alt="">
              <span>facebook</span>
            </div>
            <button class="btn btn-sm follow_btn" mat-button>Follow</button>
          </div>
          <!-- <iframe
             src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FRewise-121533909692117%2F%3Fmodal%3Dadmin_todo_tour&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
             style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true"
             allow="encrypted-media"></iframe> -->
          <iframe
            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FPeacefullNarmetta&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
            scrolling="no" data-height="700" height="700" frameborder="0" allowfullscreen="true"
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
        </div>
      </div>
      <div class="latest_photo_column right" fxLayout="column" fxFlex.xl="70" fxFlex.lg="70" fxFlex.md="60"
        fxFlex.sm="100" fxFlex.xs="100" fxFlexFill>
        <video muted preload="auto" controls>
          <source src="../../../../../assets/images/Narmetta Vedio (Nov, 2020).mp4" type="video/mp4">
        </video>
      </div>
    </div>
  </div>
</section>
<!-- E - governance -->
<!-- <section class="e_governance_bg">
  <img src="../../../../../assets/images/e_governance_tractor.png" alt="e_governance_tractor">
</section>
<app-village-virtual-offices></app-village-virtual-offices> -->
